'use strict';

// A sample component

const Loader = {
    init: function() {
        // Determine if is the first time on this page
        if (!localStorage.getItem('beenHereBefore')) {
            localStorage.setItem('beenHereBefore', 'true');
            document.addEventListener('DOMContentLoaded', function() {
                document.querySelector('.loader').style.display = 'flex';
                Loader.function1();
            });
        }
    },
    function1: function() {
        setTimeout(() => {
            document.querySelector('.images').style.transform = 'scale(3)';
        }, 1000);
        Loader.function2();
    },
    function2: function() {
        setTimeout(() => {
            document.querySelector('.rightpart').style.transform =
                'translate(400%)';
            document.querySelector('.hsuite').style.transform =
                'translate(400%)';
            document.querySelector('.leftpart').style.transform =
                'translate(-400%)';
            document.querySelector('.h').style.transform = 'translate(-400%)';
        }, 2000);
        setTimeout(() => {
            document.querySelector('.loader').style.display = 'none';
        }, 2500);
    },
};

export default Loader;



// WEBPACK FOOTER //
// ./src/scripts/components/Loader.js